export default __webpack_public_path__ + "static/data-about-screenshot-3-1ed295401a06da731b44009ab6e0c85d.png";